import { intake } from '$lib/public/intake-client'
import type { paths } from '$lib/api/generated'

export type Branding =
  paths['/public/branding/{pmSlug}/{propertySlug}']['get']['responses'][200]['content']['application/json']

export async function fetchBranding(pmSlug: string, propertySlug: string): Promise<Branding | null> {
  const { data, error } = await intake.GET('/public/branding/{pmSlug}/{propertySlug}', {
    params: { path: { pmSlug, propertySlug } },
  })
  if (error || !data) return null
  return data
}
